import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import CookiePreferencesDialog from './CookiePreferencesDialog';
import { legalConfig } from '../config/legal';
import './SiteFooter.css';

const SiteFooter = ({ className = '' }) => {
  const { t } = useTranslation('common');
  const [showPreferences, setShowPreferences] = useState(false);

  return (
    <>
      <footer className={`site-footer ${className}`.trim()}>
        <div className="site-footer__content">
          <p className="site-footer__copyright">
            &copy; {new Date().getFullYear()} {legalConfig.entityName}. {t('footerCopyright')}
          </p>
          <nav className="site-footer__links" aria-label={t('legalNav')}>
            <Link to="/privacy">{t('privacyPolicy')}</Link>
            <Link to="/terms">{t('termsOfService')}</Link>
            <Link to="/cookies">{t('cookiePolicy')}</Link>
            <button
              type="button"
              className="site-footer__cookie-settings"
              onClick={() => setShowPreferences(true)}
            >
              {t('cookieSettings')}
            </button>
          </nav>
        </div>
      </footer>
      <CookiePreferencesDialog
        open={showPreferences}
        onClose={() => setShowPreferences(false)}
        onSaved={() => setShowPreferences(false)}
      />
    </>
  );
};

export default SiteFooter;
